import * as React from 'react';
import { useSelector } from 'react-redux';

import { fetchStats } from '../../actions/offers';
import { HousesFilter } from '../../components/HousesFilter';
import { getHouses } from '../../selectors/newbuilding';
import { getSelectedHouseId } from '../../selectors/offers';
import { trackHouseClick } from './tracking';
import { useAppDispatch } from '../../hooks/useAppDispatch';

export function HousesFilterContainer() {
  const dispatch = useAppDispatch();
  const selectedHouseId = useSelector(getSelectedHouseId);
  const houses = useSelector(getHouses);

  const onHouseClick = React.useCallback(
    (houseId: number | undefined) => {
      const house = houses.find(el => el.houseId === houseId);

      dispatch(fetchStats(houseId));
      trackHouseClick(house ? house.houseName : undefined);
    },
    [dispatch, houses],
  );

  if (!houses || houses.length < 2) {
    return null;
  }

  return <HousesFilter selectedHouseId={selectedHouseId} houses={houses} onHouseClick={onHouseClick} />;
}
